import { NextRequest, NextResponse } from 'next/server';
import { db } from '@/lib/db';

export async function GET(request: NextRequest) {
  try {
    const { searchParams } = new URL(request.url);
    const email = searchParams.get('email');

    if (!email) {
      return NextResponse.json(
        { error: 'Email is required' },
        { status: 400 }
      );
    }

    const trainers = await db.trainers.findByOwnerEmail(email);

    if (trainers.length === 0) {
      return NextResponse.json(
        { trainer: null },
        { status: 200 }
      );
    }

    return NextResponse.json({
      success: true,
      trainer: trainers[0], // Return first trainer profile
    });
  } catch (error) {
    console.error('Error fetching trainer profile:', error);
    return NextResponse.json(
      { error: 'Failed to fetch trainer profile' },
      { status: 500 }
    );
  }
}
